import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader";

// components
import { DropDown as DropDownContext } from "core/DropDown/index.js";
import Promo from "./Promo";
import AsideLinks from "./AsideLinks";

//styles
import breakpoints from "core/breakpoints";
import { convertPxToRem } from "frontend/components/helpers";
const WrapperStyled = styled.div`
    display: flex;
    gap: ${convertPxToRem(16)};
    text-align: left;

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        flex-wrap: wrap;
    }
`;

// data
import { promos, getLightDarkProps } from "./data";

// component
const DropDown = () => {
    const { isDarkMode } = useSiteHeader();
    const lightDarkProps = getLightDarkProps(isDarkMode);
    return (
        <DropDownContext>
            <WrapperStyled>
                {promos.map(promo => {
                    return (
                        <Promo
                            key={promo.id}
                            {...promo}
                            lightDarkProps={lightDarkProps}
                        />
                    );
                })}
                <AsideLinks
                    linkColor={lightDarkProps.linkColor}
                    linkHoverColor={lightDarkProps.linkHoverColor}
                />
            </WrapperStyled>
        </DropDownContext>
    );
};

export default DropDown;
